import { render, staticRenderFns } from "./CompetitionReleaseTime.vue?vue&type=template&id=92b27802&scoped=true"
import script from "./CompetitionReleaseTime.vue?vue&type=script&lang=js"
export * from "./CompetitionReleaseTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b27802",
  null
  
)

export default component.exports